module.exports = __webpack_public_path__ + "static/img/brower-count-default.1317cd65.png";